import React, {Component} from 'react'
import Select from 'react-select'

class CustomSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: props.options || [],
            selectedOption: this.props.value,
        }
       
        const defaultCallback = () => {}
        this.className = this.props.className
        this.name = this.props.name
        this.multi = this.props.multi || false        
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.didReceiveNewOptions = this.didReceiveNewOptions.bind(this)

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            let val = ''
            let label=''
            if (this.multi) {
                val = []
            }
            if (selectedOption) {
                if (this.multi) {
                    val = selectedOption.map(option => option.value)
                    label=selectedOption.map(option=> option.label).join(',')
                } else {
                    val = selectedOption.value
                    label = selectedOption.label
                }
            }

            this.onChange(val,label)
        });
    }
    
    componentWillReceiveProps(nextProps) {
        if(! this.didReceiveNewOptions(nextProps.options)) {
            return
        }

        this.setState({
            selectedOption: nextProps.value || (this.multi ? [] : ''),
            options: nextProps.options,
        })
    }

    didReceiveNewOptions(newOptions) {
        const currentOptions = this.state.options
        if(newOptions.length != currentOptions.length) {
            return true
        }

        for(let i = 0; i < currentOptions.length; i++) {
            if(newOptions[i]["value"] != currentOptions[i]["value"]) {
                return true
            }
        }
        return false
    }

    render() {
        return (
            <Select
                multi={this.multi}
                name={this.name}
                className={this.className}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default CustomSelect





// WEBPACK FOOTER //
// ./src/common/search-filter/others/customSelect.component.jsx